import React, { useState } from "react";
import { Alert as BSAlert } from "react-bootstrap";

import { IAlertParams } from "../types/shared";

const FormAlert = (params: IAlertParams): React.JSX.Element => {
    const [show, setShow] = useState(true);

    return (
        <BSAlert
            data-testid="alert"
            variant={params.level}
            className={params.settings || ""}
            show={show}
            onClose={() => setShow(false)}
            dismissible={params.dismissible || false}
        >
            {params.title && (
                <BSAlert.Heading as="h5">{params.title}</BSAlert.Heading>
            )}
            <p className="p-0 m-0">{params.text}</p>
        </BSAlert>
    );
};

export default FormAlert;
